export const companySearchResults = {
  results: [
    {
      company: {
        localizedData: {
          address: {
            postCodes: [],
          },
          legalData: {
            secondaryNames: [],
          },
          communicationChannels: [],
        },
        communicationChannels: [
          {
            typeCode: 'PHONE_NUMBER',
            value: '+33 1 78 99 90 00',
          },
        ],
        employeesData: {
          minNumber: 1000,
          maxNumber: 1999,
        },
        financialData: {
          shareCapitalAmount: 79248128,
          currencyCode: 'EUR',
        },
        groupLinks: [
          {
            groupId: '4541',
            isGroupHead: false,
          },
        ],
        companyId: '397675',
        address: {
          streetNumber: '14',
          streetName: 'RUE MARC BLOCH',
          complementaryStreetName: '14 A 16',
          postCodes: [
            {
              postCodeTypeCode: 'POSTCODE',
              postCodeValue: '92110',
            },
          ],
          town: 'CLICHY',
          subdivisionCode: '92',
          countryCode: 'FR',
        },
        legalData: {
          companyName: 'MONOPRIX',
          secondaryNames: [],
          effectiveDate: '1955-01-01',
          creationDate: '1955-01-01',
          businessStartDate: '2014-05-27',
          companyStatusCode: 'A',
          companyTypeCode: 'C',
          legalFormCode: 'SAS',
          tradeSectors: [
            {
              nomenclatureCode: 'NAF',
              isMainTradeSector: true,
            },
            {
              nomenclatureCode: 'NAF',
              isMainTradeSector: false,
            },
            {
              nomenclatureCode: 'NAF',
              isMainTradeSector: false,
            },
            {
              nomenclatureCode: 'NAF',
              isMainTradeSector: false,
            },
            {
              nomenclatureCode: 'NAF',
              isMainTradeSector: false,
            },
            {
              nomenclatureCode: 'NAF',
              isMainTradeSector: false,
            },
            {
              nomenclatureCode: 'NAF',
              isMainTradeSector: false,
            },
            {
              nomenclatureCode: 'NAF',
              isMainTradeSector: false,
            },
            {
              nomenclatureCode: 'NAF',
              isMainTradeSector: false,
            },
            {
              nomenclatureCode: 'NAF',
              isMainTradeSector: false,
            },
            {
              nomenclatureCode: 'NAF',
              isMainTradeSector: false,
            },
            {
              nomenclatureCode: 'NAF',
              isMainTradeSector: false,
            },
          ],
          languageCode: 'FR',
          isPublicCompany: false,
          isDataProtected: false,
        },
        branches: [
          {
            branchId: '25522562',
            companyId: '397675',
            companyIdentifiers: [
              {
                priorityNumber: 9,
                isNationalIdentifier: false,
                idTypeCode: 'SIRET',
                idValue: '55201802000446',
              },
            ],
            address: {
              streetNumber: '87',
              streetName: 'RUE GAMBETTA',
              postCodes: [
                {
                  postCodeTypeCode: 'POSTCODE',
                  postCodeValue: '64500',
                },
              ],
              town: 'SAINT-JEAN-DE-LUZ',
              subdivisionCode: '64',
              countryCode: 'FR',
            },
            localizedData: {
              address: {
                postCodes: [],
              },
              legalData: {},
              communicationChannels: [],
            },
            legalData: {
              companyName: 'MONOPRIX',
              creationDate: '1900-01-01',
              companyTypeCode: 'L',
              tradeSectors: [
                {
                  nomenclatureCode: 'NAF',
                  isMainTradeSector: true,
                },
              ],
              languageCode: 'FR',
              isPublicCompany: false,
              isDataProtected: false,
            },
            communicationChannels: [
              {
                typeCode: 'PHONE_NUMBER',
                value: '+33 5 59 26 18 62',
              },
            ],
          },
          {
            branchId: '25522686',
            companyId: '397675',
            companyIdentifiers: [
              {
                priorityNumber: 9,
                isNationalIdentifier: false,
                idTypeCode: 'SIRET',
                idValue: '55201802001774',
              },
            ],
            address: {
              streetName: 'LOT DU PONT 2',
              postCodes: [
                {
                  postCodeTypeCode: 'POSTCODE',
                  postCodeValue: '13750',
                },
              ],
              town: "PLAN D'ORGON",
              subdivisionCode: '13',
              countryCode: 'FR',
            },
            localizedData: {
              address: {
                postCodes: [],
              },
              legalData: {},
              communicationChannels: [],
            },
            legalData: {
              companyName: 'MONOPRIX',
              creationDate: '1994-10-01',
              companyTypeCode: 'L',
              tradeSectors: [
                {
                  nomenclatureCode: 'NAF',
                  isMainTradeSector: true,
                },
              ],
              languageCode: 'FR',
              isPublicCompany: false,
              isDataProtected: false,
            },
            communicationChannels: [],
          },
          {
            branchId: '118546542',
            companyId: '397675',
            companyIdentifiers: [
              {
                priorityNumber: 9,
                isNationalIdentifier: false,
                idTypeCode: 'SIRET',
                idValue: '55201802001832',
              },
            ],
            address: {
              streetName: 'LA CROIX BRISEE',
              complementaryStreetName: 'PARC DES HAUTS DE WISSOUS II',
              postCodes: [
                {
                  postCodeTypeCode: 'POSTCODE',
                  postCodeValue: '91320',
                },
              ],
              town: 'WISSOUS',
              subdivisionCode: '91',
              countryCode: 'FR',
            },
            localizedData: {
              address: {
                postCodes: [],
              },
              legalData: {},
              communicationChannels: [],
            },
            legalData: {
              companyName: 'MONOPRIX',
              companyTypeCode: 'L',
              tradeSectors: [
                {
                  nomenclatureCode: 'NAF',
                  isMainTradeSector: true,
                },
              ],
              languageCode: 'FR',
              isPublicCompany: false,
              isDataProtected: false,
            },
            communicationChannels: [],
          },
          {
            branchId: '25522623',
            companyId: '397675',
            companyIdentifiers: [
              {
                priorityNumber: 9,
                isNationalIdentifier: false,
                idTypeCode: 'SIRET',
                idValue: '55201802001147',
              },
            ],
            address: {
              streetNumber: '142',
              streetName: 'AV FRANKLIN ROOSEVELT',
              postCodes: [
                {
                  postCodeTypeCode: 'POSTCODE',
                  postCodeValue: '69500',
                },
              ],
              town: 'BRON',
              subdivisionCode: '69',
              countryCode: 'FR',
            },
            localizedData: {
              address: {
                postCodes: [],
              },
              legalData: {},
              communicationChannels: [],
            },
            legalData: {
              companyName: 'MONOPRIX',
              creationDate: '1994-09-30',
              companyTypeCode: 'L',
              tradeSectors: [
                {
                  nomenclatureCode: 'NAF',
                  isMainTradeSector: true,
                },
              ],
              languageCode: 'FR',
              isPublicCompany: false,
              isDataProtected: false,
            },
            communicationChannels: [],
          },
          {
            branchId: '25522611',
            companyId: '397675',
            companyIdentifiers: [
              {
                priorityNumber: 9,
                isNationalIdentifier: false,
                idTypeCode: 'SIRET',
                idValue: '55201802001022',
              },
            ],
            address: {
              streetNumber: '334',
              streetName: 'AV DE L YSER',
              complementaryStreetName: 'PARC DE MERIGNAC VILLE',
              postCodes: [
                {
                  postCodeTypeCode: 'POSTCODE',
                  postCodeValue: '33700',
                },
              ],
              town: 'MERIGNAC',
              subdivisionCode: '33',
              countryCode: 'FR',
            },
            localizedData: {
              address: {
                postCodes: [],
              },
              legalData: {},
              communicationChannels: [],
            },
            legalData: {
              companyName: 'MONOPRIX',
              creationDate: '1994-09-30',
              companyTypeCode: 'L',
              tradeSectors: [
                {
                  nomenclatureCode: 'NAF',
                  isMainTradeSector: true,
                },
              ],
              languageCode: 'FR',
              isPublicCompany: false,
              isDataProtected: false,
            },
            communicationChannels: [],
          },
        ],
        companyIdentifiers: [
          {
            priorityNumber: 9,
            isNationalIdentifier: false,
            idTypeCode: 'HRM',
            idValue: '1180334813',
          },
          {
            priorityNumber: 9,
            isNationalIdentifier: false,
            idTypeCode: 'DUN',
            idValue: '275238269',
          },
          {
            priorityNumber: 1,
            isNationalIdentifier: true,
            idTypeCode: 'SIREN',
            idValue: '552018020',
          },
          {
            priorityNumber: 9,
            isNationalIdentifier: false,
            idTypeCode: 'SIRET',
            idValue: '55201802001808',
          },
          {
            priorityNumber: 9,
            isNationalIdentifier: false,
            idTypeCode: 'LEI',
            idValue: '969500DZ56QVIKRIU954',
          },
        ],
      },
      score: 1.0,
      sources: ['ES'],
      isHeadQuarterMatched: true,
      isBranchMatched: true,
    },
    {
      company: {
        localizedData: {
          address: {
            postCodes: [],
          },
          legalData: {
            secondaryNames: [],
          },
          communicationChannels: [],
        },
        communicationChannels: [
          {
            typeCode: 'PHONE_NUMBER',
            value: '+33 2 51 95 18 21',
          },
        ],
        employeesData: {
          minNumber: 10,
          maxNumber: 19,
        },
        financialData: {
          shareCapitalAmount: 534400,
          currencyCode: 'EUR',
        },
        groupLinks: [
          {
            groupId: '22677318',
            isGroupHead: false,
          },
        ],
        companyId: '24518650',
        address: {
          streetNumber: '53',
          streetName: 'BD   DE LA HOULE',
          postCodes: [
            {
              postCodeTypeCode: 'POSTCODE',
              postCodeValue: '35800',
            },
          ],
          town: 'SAINT BRIAC SUR MER',
          subdivisionCode: '35',
          countryCode: 'FR',
        },
        legalData: {
          companyName: 'BEAUCE BRETAGNE',
          secondaryNames: [],
          effectiveDate: '2002-06-25',
          creationDate: '1996-12-16',
          businessStartDate: '2010-02-26',
          companyStatusCode: 'A',
          companyTypeCode: 'C',
          legalFormCode: 'SAS',
          tradeSectors: [
            {
              nomenclatureCode: 'NAF',
              isMainTradeSector: true,
            },
            {
              nomenclatureCode: 'NAF',
              isMainTradeSector: false,
            },
          ],
          languageCode: 'FR',
          isPublicCompany: false,
          isDataProtected: false,
        },
        branches: [
          {
            branchId: '22377195',
            companyId: '24518650',
            companyIdentifiers: [
              {
                priorityNumber: 9,
                isNationalIdentifier: false,
                idTypeCode: 'SIRET',
                idValue: '41014619500038',
              },
            ],
            address: {
              streetNumber: '17',
              streetName: 'RUE   DE L HOTEL DE VILLE',
              postCodes: [
                {
                  postCodeTypeCode: 'POSTCODE',
                  postCodeValue: '85100',
                },
              ],
              town: 'LES SABLES D OLONNE',
              subdivisionCode: '85',
              countryCode: 'FR',
            },
            localizedData: {
              address: {
                postCodes: [],
              },
              legalData: {},
              communicationChannels: [],
            },
            legalData: {
              companyName: 'MONOPRIX',
              creationDate: '1997-01-01',
              companyTypeCode: 'L',
              tradeSectors: [
                {
                  nomenclatureCode: 'NAF',
                  isMainTradeSector: true,
                },
              ],
              languageCode: 'FR',
              isPublicCompany: false,
              isDataProtected: false,
            },
            communicationChannels: [],
          },
          {
            branchId: '22377197',
            companyId: '24518650',
            companyIdentifiers: [
              {
                priorityNumber: 9,
                isNationalIdentifier: false,
                idTypeCode: 'SIRET',
                idValue: '41014619500053',
              },
            ],
            address: {
              streetNumber: '6',
              streetName: 'RUE   DE L EGLISE',
              postCodes: [
                {
                  postCodeTypeCode: 'POSTCODE',
                  postCodeValue: '85100',
                },
              ],
              town: 'LES SABLES D OLONNE',
              subdivisionCode: '85',
              countryCode: 'FR',
            },
            localizedData: {
              address: {
                postCodes: [],
              },
              legalData: {},
              communicationChannels: [],
            },
            legalData: {
              companyName: 'MONOPRIX',
              creationDate: '1997-01-01',
              companyTypeCode: 'L',
              tradeSectors: [
                {
                  nomenclatureCode: 'NAF',
                  isMainTradeSector: true,
                },
              ],
              languageCode: 'FR',
              isPublicCompany: false,
              isDataProtected: false,
            },
            communicationChannels: [],
          },
        ],
        companyIdentifiers: [
          {
            priorityNumber: 9,
            isNationalIdentifier: false,
            idTypeCode: 'HRM',
            idValue: '0207556211',
          },
          {
            priorityNumber: 1,
            isNationalIdentifier: true,
            idTypeCode: 'SIREN',
            idValue: '410146195',
          },
          {
            priorityNumber: 9,
            isNationalIdentifier: false,
            idTypeCode: 'SIRET',
            idValue: '41014619500061',
          },
        ],
      },
      score: 0.998,
      sources: ['ES'],
      isHeadQuarterMatched: false,
      isBranchMatched: true,
    },
  ],
};
